// extracted by mini-css-extract-plugin
export default {"bg":"CommertialProperties_bg__rfTek","container":"CommertialProperties_container__BryIm","left":"CommertialProperties_left__Vg4lS","right":"CommertialProperties_right__V4zop"};